export const clearLocalStorage = (keysToMantain) => {
  for (var i = 0; i < localStorage.length; i++) {
    var clave = localStorage.key(i);
    if (!keysToMantain?.includes(clave)) {
      localStorage.removeItem(clave);
    }
  }
};
